import axios from 'axios';
export const getShiftWorkbench=(unit: string) =>{
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench?where=` + unit
  );
}
export const AddShiftWorkbench=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/create`,
    obj,
    { headers }
  );
}
export const EditShiftWorkbench=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/edit`,
    obj,
    { headers }
  );
}
export const DeleteShiftWorkbench=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/delete`,
    obj,
    { headers }
  );
}